import { render, staticRenderFns } from "./select-component.vue?vue&type=template&id=3f4ffdd2&scoped=true&"
import script from "./select-component.vue?vue&type=script&lang=ts&"
export * from "./select-component.vue?vue&type=script&lang=ts&"
import style0 from "./select-component.vue?vue&type=style&index=0&id=3f4ffdd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ffdd2",
  null
  
)

export default component.exports